import React from 'react';
import KpiChart from 'components/report-content/components/kpi-chart/KpiChart';
import KpiChartEditPanel from './KpiChartEditPanel';
import { AbstractComponentBuilder, ComponentSettingsKpiChart } from '@report-content';

export default class KpiChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsKpiChart> {
    getComponent() {
        return (
            <KpiChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <KpiChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
